module.exports = __webpack_public_path__ + "static/media/cctv-camera.40269b36.svg";